import { Tag } from "@impero-com/ui";

import * as theme from "./theme.css";

export interface TagAndCategoryProps {
    categoryName: string;
    tagName: string;
}

export function TagAndCategory({ categoryName, tagName }: TagAndCategoryProps) {
    return (
        <Tag wrap className={theme.tagElementsContainer}>
            <strong>{categoryName}:</strong> {tagName}
        </Tag>
    );
}
